// @flow

import { observer } from "mobx-react";
import * as React from "react";
import { DraggableCore } from "react-draggable";

type Props = {
    disabled?: boolean,
    children: React.Node
};

@observer
export default class DraggableCoreSwitcher extends React.Component<Props> {
    render() {
        const children = this.props.children;

        if (this.props.disabled) {
            return <div>{children}</div>;
        }

        return <DraggableCore {...this.props}>{children}</DraggableCore>;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/DraggableCoreSwitcher/DraggableCoreSwitcher.js